import request from 'superagent'

let storedToken
export function setToken (token) {
  storedToken = token
}

export function getToken () {
  return storedToken
}

export function get (path, headers = {}) {
  headers.token = storedToken ? storedToken : ''
  headers['Accept-Language'] = 'sv'
  return new Promise((resolve, reject) => {
    request
      .get(path)
      .set(headers)
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          if (err.status === 404) {
            resolve(null)
          } else {
            reject(err)
          }
        } else {
          resolve(res.body)
        }
      })
  })
}

export function del (path, headers = {}) {
  headers.token = storedToken ? storedToken : ''
  headers['Accept-Language'] = 'sv'
  return new Promise((resolve) => {
    request
      .delete(path)
      .set(headers)
      .withCredentials()
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          resolve(err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export function post (path, data, headers = {}) {
  headers.token = storedToken ? storedToken : ''
  headers['Accept-Language'] = 'sv'
  return new Promise((resolve, reject) => {
    request
      .post(path)
      .set(headers)
      .send(data)
      .accept('application/json')
      .end((err, res) => {
        if (err) {
          reject(res && res.body ? res.body : err)
        } else {
          resolve(res.body)
        }
      })
  })
}

export default {
  get,
  post,
  del,
  setToken
}



// WEBPACK FOOTER //
// ./src/core/HttpClient.js